import { clamp } from '../../render/utils/math';

export const brightness = {
  name: 'brightness',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;

uniform float u_brightness;

void main() {
    vec4 color = texture2D(u_image, v_texCoord);
    vec3 bright_color = color.rgb + vec3(u_brightness);
    vec3 clamped_color = clamp(bright_color, 0.0, 1.0);
    gl_FragColor = vec4(clamped_color, color.a);
}
`,
  uniforms: [
    {
      name: 'u_brightness',
      normalize: (val: number) => clamp(-100 + 200 * (val / 100), -100, 100) / 100,
    },
  ],
};
